import React from 'react';
import ErrorContainer from './containers';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return <ErrorContainer message={t('errors.notFound')} />;
};

export default NotFound;
